module.exports = __webpack_public_path__ + "img/galleria-original-1920.b31d66c7.png";